import { HistorySortBy, Id } from "PFTypes";
import { createContext, useContext } from "react";

export type ActivityHistoryFilters = {
  eventType: string[];
  operatorId: Id[];
  createdAtMin: string | null;
  createdAtMax: string | null;
};

export const EMPTY_ACTIVITY_HISTORY_FILTERS: ActivityHistoryFilters = {
  eventType: [],
  operatorId: [],
  createdAtMin: null,
  createdAtMax: null
};

export type ActivityHistoryContextType = {
  sortBy: HistorySortBy;
  setSortBy: React.Dispatch<React.SetStateAction<HistorySortBy>>;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  filters: ActivityHistoryFilters;
  setFilters: React.Dispatch<React.SetStateAction<ActivityHistoryFilters>>;
};

export const ActivityHistoryContext = createContext<ActivityHistoryContextType>(
  {} as ActivityHistoryContextType
);

export const useActivityHistoryContext = () => useContext(ActivityHistoryContext);
